import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _mergeProps({ class: "container" }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 16)
  ]))
}